import { Outlet, useLocation } from 'react-router-dom';
import { Navigate } from 'react-router-dom';
import { LOGIN_PATH } from '@constants/cp-paths.js';
import { OMS_DASHBOARD_PATH, LOGIN_PATH as DUBIZZLE_LOGIN_PATH } from '@constants/seller-center-paths.js';
import { buildLoginRedirectParam } from '@utils/utils';
import { isCP } from '../../../utils/app-utils';

const ProtectedRoute = ({ user = true, redirect = true }) => {
  const location = useLocation();

  const getLoginRedirectUrl = () => {
    const loginPath = isCP() ? LOGIN_PATH : DUBIZZLE_LOGIN_PATH;
    if (!redirect) return loginPath;

    const redirectParam = buildLoginRedirectParam(location?.pathname, location?.search);

    return `${loginPath}?redirect_to=${redirectParam}`;
  };

  return user ? (
    <Outlet />
  ) : (
    <Navigate to={getLoginRedirectUrl()} />
  );
};

export default ProtectedRoute;
